import { render, staticRenderFns } from "./WorkItemCreateDialog.vue?vue&type=template&id=44111334&scoped=true"
import script from "./WorkItemCreateDialog.vue?vue&type=script&lang=js"
export * from "./WorkItemCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkItemCreateDialog.vue?vue&type=style&index=0&id=44111334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44111334",
  null
  
)

export default component.exports